import { PayloadAction } from '@reduxjs/toolkit'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { call, put, select, takeEvery, takeLeading } from 'redux-saga/effects'
import {
  cancelAgentCommissionSettlement,
  createAgentCommissionSettlement,
  getAgentCommissionPreview,
  getAgentCommissionSettlements,
  getAgentCommissionSettlement,
  getAgentOptions,
  payAgentCommissionSettlement
} from '@http/agentCommissionsService'
import { CreateAgentSettlementPayload, LoadAgentCommissionPayload, MutateAgentSettlementPayload } from '../types'
import {
  agentCommissionLoaded,
  agentsLoaded,
  cancelAgentSettlement,
  createAgentSettlement,
  loadAgentCommission,
  loadAgents,
  loadSettlementDetail,
  mutationDone,
  payAgentSettlement,
  requestFailed,
  settlementDetailLoaded
} from './agentCommissionsSlice'

const message = (error: Error) => error.message || 'No fue posible completar la operación.'
function* loadAgentsHttp() {
  const { cocap } = yield select(selectCredentials)
  try {
    yield put(agentsLoaded(yield call(getAgentOptions, cocap)))
  } catch (error) {
    yield put(requestFailed(message(error)))
  }
}
function* loadHttp(action: PayloadAction<LoadAgentCommissionPayload>) {
  const { cocap } = yield select(selectCredentials)
  try {
    const preview = yield call(getAgentCommissionPreview, cocap, action.payload.period, action.payload.agentId)
    const settlements = yield call(getAgentCommissionSettlements, cocap, action.payload.agentId)
    yield put(agentCommissionLoaded({ preview, settlements }))
  } catch (error) {
    yield put(requestFailed(message(error)))
  }
}
function* createHttp(action: PayloadAction<CreateAgentSettlementPayload>) {
  const { cocap } = yield select(selectCredentials)
  try {
    yield call(createAgentCommissionSettlement, cocap, action.payload)
    yield put(mutationDone('El período fue liquidado.'))
    yield put(loadAgentCommission(action.payload))
  } catch (error) {
    yield put(requestFailed(message(error)))
  }
}
function* detailHttp(action: PayloadAction<string>) {
  const { cocap } = yield select(selectCredentials)
  try {
    yield put(settlementDetailLoaded(yield call(getAgentCommissionSettlement, cocap, action.payload)))
  } catch (error) {
    yield put(requestFailed(message(error)))
  }
}
function* payHttp(action: PayloadAction<MutateAgentSettlementPayload>) {
  const { cocap } = yield select(selectCredentials)
  try {
    yield call(payAgentCommissionSettlement, cocap, action.payload.settlementId)
    yield put(mutationDone('La comisión fue marcada como pagada.'))
    yield put(loadAgentCommission(action.payload))
  } catch (error) {
    yield put(requestFailed(message(error)))
  }
}
function* cancelHttp(action: PayloadAction<MutateAgentSettlementPayload>) {
  const { cocap } = yield select(selectCredentials)
  try {
    yield call(cancelAgentCommissionSettlement, cocap, action.payload.settlementId, action.payload.reason || '')
    yield put(mutationDone('La liquidación fue cancelada.'))
    yield put(loadAgentCommission(action.payload))
  } catch (error) {
    yield put(requestFailed(message(error)))
  }
}
export default function* agentCommissionsSaga() {
  yield takeEvery(loadAgents.type, loadAgentsHttp)
  yield takeEvery(loadAgentCommission.type, loadHttp)
  yield takeEvery(loadSettlementDetail.type, detailHttp)
  yield takeLeading(createAgentSettlement.type, createHttp)
  yield takeLeading(payAgentSettlement.type, payHttp)
  yield takeLeading(cancelAgentSettlement.type, cancelHttp)
}
